import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

export class ContentReportsProxy {
    async list(status = 'open') {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/content-reports?status=${status}`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async openCount() {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/content-reports/open-count`);
        if (!res.ok) throw new Error(res.statusText);
        return (await res.json()).count;
    }

    async setStatus(id, status) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/content-reports/${id}/status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ status }),
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }
}
